import React, {Component} from 'react'
import {connect} from 'react-redux'
import {actions} from 'react-redux-form'
import {Grid, Row, Col} from 'react-bootstrap'
import EditCategoryForm from './category-edit-form'
import BackLink from '../../../../common/back-link/index'
import PageTitle from "../../../../common/page-title/index";
import {getCategory} from '../../../../../actions/news'

class EditCategory extends Component {

  constructor(props){
    super(props);
  }

  componentWillMount() {
    const id = +this.props.match.params.id;
    if(id){
      this.props.dispatch(getCategory(id));
    }
  }

  componentWillUnmount(){
    this.props.dispatch(actions.reset('deep.admin_news.category'));
    this.props.dispatch({type: 'CLEAR_EDIT_NEWS_CATEGORY'});
  }

  render(){
    return(
      <Grid bsClass="container" fluid className="news">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/news/categories"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>Add/Edit news category</PageTitle>
          </Col>
        </Row>
        <EditCategoryForm category={this.props.category}/>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    category: state.news.categories.category,
    fetched: state.news.categories.fetched,
    fetching: state.news.categories.fetching,
  };
};

export default connect(mapStateToProps)(EditCategory);



// WEBPACK FOOTER //
// ./src/components/admin/news/categories/edit/index.jsx